<template>
    <transition-group :name="transition" appear>
        <div
            v-if="show && hasBackdrop"
            key="modal-backdrop"
            class="modal-backdrop fade show"
            :style="{ zIndex: baseZIndex + zIndex * 2 }"
        ></div>
            <!-- :class="{'backdrop': hasBackdrop && relativeBackdrop}" -->

        <div
            v-if="show"
            key="modal"
            name="modal"
            class="modal fade show"
            :class="{'draggable': draggable, 'resizable': resizable}"
            tabindex="-1"
            role="dialog"
            aria-labelledby="Modal"
            aria-hidden="true"
            :style="getStyle"
            @click="closeBackdrop">
            <div class="modal-dialog" role="document" :class="getClass">
                <!-- v-draggable="draggableValue" -->
                <div class="modal-content">
                    <!-- <slot name="modal-header"> -->
                        <div
                            class="modal-header"
                            v-if="needHeader"
                            :ref="handleId">
                            <h5 class="modal-title">
                                {{ modalTitle }}
                            </h5>
                            <div class="modal-header-actions">
                                <slot name="modal-header-actions"></slot>
                                <button
                                    v-if="closeBtn"
                                    type="button"
                                    class="close text-midnight-blue opacity-100"
                                    aria-label="Close"
                                    data-dismiss="modal"
                                    @click="close">
                                    <span aria-hidden="true">
                                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="icon-close svg-inline--fa fa-times fa-w-13"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    <!-- </slot> -->

                    <div class="modal-body" :class="[bodyClass, {'pt-sm-4 mt-sm-2': !needHeader, 'text-center': contentCentered}]">
                          <slot></slot>
                    </div>

                    <slot name="modal-footer">
                        <div class="modal-footer border-0" v-if="needFooter" :class="{'pt-0': !needHeader, 'justify-content-center': contentCentered}">
                            <div class="row" >
                                <div class="col-6 col-sm px-0" :class="[saveButtonOptions.visible ? (size=='small' ? 'px-sm-2' : 'px-sm-3') : '']">
                                    <button
                                            v-if="saveButtonOptions.visible"
                                            type="button"
                                            @click="save"
                                            :class="{ ...saveButtonOptions.btnClass }">
                                        {{ $t(saveButtonOptions.title) }}
                                    </button>
                                </div>
                                <div class="col-6 col-sm px-0" :class="[cancelButtonOptions.visible ? (size=='small' ? 'px-sm-2' : 'px-sm-3') : '']">
                                    <button
                                            v-if="cancelButtonOptions.visible"
                                            type="button"
                                            :class="{ ...cancelButtonOptions.btnClass }"
                                            data-dismiss="modal"
                                            @click.stop="close">
                                        {{ $t(cancelButtonOptions.title) }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </transition-group>
</template>

<script>
// import { Draggable as DraggableDirective} from 'draggable-vue-directive';
// import { detectMobile } from "@config/browser";

const modals = {count: 0};

export default {
    directives: {
        // Draggable: DraggableDirective,
    },
    props: {
        /* Shows/hides the modal */
        show: Boolean,
        /* The title of the modal shown in .modal-header div. If empty title is not rendered */
        title: String,
        /* :class object which is attached to the modal dialog element */
        modalClass: {
            type: [String, Object],
        },
        centered: {
            type: Boolean,
            default: false
        },
        needHeader: {
            type: Boolean,
            default: true
        },
        needFooter: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: ''
        },
        contentCentered: {
            type: Boolean,
            default: false
        },
        /* Whether to display backdrop element for this dialog. It is added to the body with calculated z-index.*/
        hasBackdrop: {
            type: Boolean,
            default: true
        },
        relativeBackdrop: {
            type: Boolean,
            default: false
        },
        backdropClose: {
            type: Boolean,
            default: false
        },
        closeBtn: {
            type: Boolean,
            default: true
        },
        /* Save button config */
        saveButton: {
            type: Object,
            default: () => ({})
        },
        /* Cancel button config */
        cancelButton: {
            type: Object,
            default: () => ({})
        },
        /*
        * Transition to use when showing the modal.
        * You need to include scss @innologica/vue-stackable-modal/src/assets/transitions/translate-fade.scss
        * */
        transition: {
            type: String,
            default: 'translate-fade'
        },
        closeOnEscape: {
            type: Boolean,
            default: false
        },
        bodyClass: {
            type: String,
            default: ''
        },
        draggable: {
            type: Boolean,
            default: false
        },
        resizable: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            handleId: "modal",
            // isDraggable: false,
            // draggableValue: {
            //     stopDragging: true,
            //     handle: undefined,
            //     resetInitialPos: false,
            //     boundingRect: undefined,
            //     boundingElement: undefined,
            // },
            sizeClasses: {
                full: 'modal-full',
                extralarge: 'modal-xl',
                large: 'modal-lg',
                medium: 'modal-md',
                small: 'modal-sm',
                responsive: 'modal-responsive',
                auto: 'modal-auto',
            },
            baseZIndex: 1060,   //$zindex-modal
            backdrop: null,
            zIndex: 0,
            modals,
        }
    },
    methods: {
        save(evt) {
            this.$emit('save', evt);
        },
        close(evt) {
            this.$emit('close', evt);
        },
        closeBackdrop(evt) {
            if (!this.hasBackdrop)
                return;

            if(evt.target && evt.target.classList.contains("modal")){
                if (evt.stopPropagation) {
                    evt.stopPropagation();
                }
                evt.preventDefault();
                if (!this.backdropClose) {
                    return false;
                }
                this.close();
            }
        },
        checkBackdrop () {
            if (!this.hasBackdrop)
                return;

            if (this.show && this.zIndex === 1) {
                document.body.classList.add('modal-open');
            } else if (!this.show && this.zIndex === this.totalModals) {
                // enableScroll()
            }

            if (this.show) {
                if(!this.relativeBackdrop){
                    // this.backdrop = document.createElement('div')
                    // this.backdrop.classList.add('modal-backdrop', 'fade', 'show')
                    // this.backdrop.style.zIndex = this.baseZIndex + this.zIndex * 2;
                    // document.body.appendChild(this.backdrop)
                }
            } else {
                if (this.backdrop) {
                    if(!this.relativeBackdrop){
                        // document.body.removeChild(this.backdrop)
                    }
                    document.body.classList.remove('modal-open')
                }
            }
        },
        handleEscape (e) {
            if (this.show && e.keyCode === 27 && this.zIndex === this.totalModals) {
                this.close();
            }
        },
        setTotalModals(show) {
            show ? modals.count++ : modals.count--;
            modals.count = modals.count < 0 ? 0 : modals.count;
            this.zIndex = modals.count;
        },
    },
    computed: {
        totalModals () {
            //global static variable
            return modals.count
        },
        getStyle () {
            let style = {};
            if (this.show){
                style.display = 'block';
            }
            style['z-index'] = this.baseZIndex + this.zIndex * 2 + 1;
            return style;
        },
        modalTitle() {
            return this.$t(this.title);
        },
        modalSize() {
            let clsSize = {};
            if(this.size){
                clsSize[this.sizeClasses[this.size]] = true;
            }
            return clsSize;
        },
        getClass () {
            let classes = {};
            let idx = this.totalModals - this.zIndex;

            classes['modal-' + idx] = true;
            classes['modal-order-' + this.zIndex] = true;

            if (this.centered) {
                classes['modal-dialog-centered'] = true;
            }
            if(this.relativeBackdrop){
                classes['header-fixed'] = true;
            }
            classes.aside = this.zIndex !== this.totalModals;
            let mclass = {};
            if(typeof this.modalClass === 'string'){
                mclass[this.modalClass] = true;
            }else{
                mclass=this.modalClass;
            }
            return {...classes, ...this.modalSize, ...mclass};
        },
        saveButtonOptions () {
            const saveButtonDefaults = {
                title: this.$t(`global.save`),
                visible: true,
                btnClass: {'btn btn-main btn-rounded z-depth-0': true}
            }
            return {...saveButtonDefaults, ...this.saveButton};
        },
        cancelButtonOptions () {
            const cancelButtonDefaults = {
                title: this.$t(`global.cancel`),
                visible: true,
                btnClass: {'btn btn-outline-main btn-rounded z-depth-0': true}
            }
            return {...cancelButtonDefaults, ...this.cancelButton};
        },
    },
    render (createElement){

    },
    mounted () {
        // if (this.show) {
        //     modals.count++;
        //     this.zIndex = modals.count;
        //     this.$emit('show', true, this.zIndex, modals.count);
        // }
        // this.$nextTick(() => {
        //     this.checkBackdrop();
        // });
    },
    destroyed () {
        if (this.show) {
            this.setTotalModals(false);
            this.$emit('show', false, this.zIndex, modals.count);
        }
        if (this.backdrop && this.show){
            document.body.removeChild(this.backdrop);
        }
        if (modals.count === 0) {
            document.body.classList.remove('modal-open');
        }

        if(this.draggable) {
            $('.modal.draggable').draggable('destroy');
        }

        if(this.resizable) {
            $('.modal.resizable .modal-content').resizable('destroy');
        }
    },
    watch: {
        show: {
            immediate: true,
            handler (value) {
                this.setTotalModals(value);
                if (!value && modals.count === 0) {
                    document.body.classList.remove('modal-open');
                }
                // this.isDraggable = this.draggable && !detectMobile();

                // this.draggableValue.stopDragging = !(this.isDraggable && value);
                // this.draggableValue.handle = this.isDraggable && value ? this.$refs[this.handleId] : undefined;
                // // this.draggableValue.boundingRect = this.draggable && value ? document.body.getBoundingClientRect() : undefined;
                // this.draggableValue.boundingElement = this.isDraggable && value ? document.body : undefined;
                // console.log(this.draggableValue.boundingRect, this.draggableValue.stopDragging, this.draggableValue.boundingElement);

                // this.$nextTick(() => {
                //     // let element = this.$refs[this.handleId];
                //     // if(element) {
                //     //     // element.$forceUpdate();
                //     //     // let rectBody = document.body.getBoundingClientRect();
                //     //     // let rect = element.getBoundingClientRect();
                //     //     // console.log(rectBody, rect, (rectBody.width/2-rect.width/2), (rectBody.height/2-rect.height/2));
                //     //     // this.draggableValue.initialPosition = {'left': (rectBody.width/2-rect.width/2), 'top': (rectBody.height/2-rect.height/2)};
                //     // }
                // });

                this.$nextTick(() => {
                    this.checkBackdrop();

                    if(value) {
                        this.$root.$helper.global.activeTooltip('boundary');
                    }else{
                        this.$root.$helper.global.hideTooltip();
                    }

                    if(this.draggable) {
                        $('.modal.draggable').draggable({
                            handle: '.modal-header',
                            cursor: 'move',
                        });
                    }

                    if(this.resizable) {
                        $('.modal.resizable .modal-content').resizable({
                            animate: false,
                            autoHide: true,
                            disabled: false,
                            minWidth: 150,
                            minHeight: 150,
                        });
                    }
                });

                this.$emit('show', value, this.zIndex, modals.count);
            }
        },
        closeOnEscape: {
            immediate: true,
            handler (value) {
                if(typeof document !== 'undefined') {
                    value ? document.addEventListener('keydown', this.handleEscape) : document.removeEventListener('keydown', this.handleEscape)
                }
            },
        }
    }
}
</script>

<style lang="scss">
    // @import "@styles/_mixins.scss";
    // @import '@styles/_theme';
    // .modal-open .ct-header {
    //     // z-index: $zindex-content-sidebar - 1 !important;
    //     @include transition(none);
    // }
</style>